import { Row, Col, Tooltip } from 'antd';
import { CheckCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { AccountCard } from '..';
import { TimeFormatter } from '../../utils/timeParser';
import color from '../../configs/color';
import {
  getFormatCurrency,
  validClassNameColumn,
} from '../../utils/commonUtils';

const onGetValidation = (keyField, items) => {
  const errorFields = items?.errorField;
  return errorFields?.find((field) => {
    return field?.key === keyField;
  });
};

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, items) => {
      const invalidField = items?.errorField?.length > 0;
      return (
        <Row align="middle" gutter={8} wrap={false}>
          <Col>
            {invalidField ? (
              <Tooltip placement="top" title="Data Invalid">
                <WarningOutlined
                  style={{ color: color.red1 }}
                  className="font-subtitle1"
                />
              </Tooltip>
            ) : (
              <Tooltip placement="top" title="Data Valid">
                <CheckCircleOutlined
                  style={{ color: color.green1 }}
                  className="font-subtitle1"
                />
              </Tooltip>
            )}
          </Col>
          <Col>
            <AccountCard name={item || '-'} />
          </Col>
        </Row>
      );
    },
    width: 280,
    fixed: 'left',
  },
  {
    title: 'Job',
    dataIndex: 'job',
    key: 'job',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Organization',
    dataIndex: 'organization_name',
    key: 'organization_name',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Phone Number',
    dataIndex: 'mobile_number',
    key: 'mobile_number',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, items) => {
      const keyField = 'mobile_number';
      const invalidField = onGetValidation(keyField, items);
      if (invalidField) {
        return (
          <div
            className={validClassNameColumn({ className: '', isValid: false })}
          >
            Data Invalid
          </div>
        );
      }
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Home Number',
    dataIndex: 'home_number',
    key: 'home_number',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, items) => {
      const keyField = 'home_number';
      const invalidField = onGetValidation(keyField, items);
      if (invalidField) {
        return (
          <div
            className={validClassNameColumn({ className: '', isValid: false })}
          >
            Data Invalid
          </div>
        );
      }
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Whatsapp Number',
    dataIndex: 'whatsapp_number',
    key: 'whatsapp_number',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, items) => {
      const keyField = 'whatsapp_number';
      const invalidField = onGetValidation(keyField, items);
      if (invalidField) {
        return (
          <div
            className={validClassNameColumn({ className: '', isValid: false })}
          >
            Data Invalid
          </div>
        );
      }
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Line ID',
    dataIndex: 'line_id',
    key: 'line_id',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Email Address',
    dataIndex: 'email_address_1',
    key: 'email_address_1',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, items) => {
      const keyField = 'email_address_1';
      const invalidField = onGetValidation(keyField, items);
      if (invalidField) {
        return (
          <div
            className={validClassNameColumn({ className: '', isValid: false })}
          >
            Data Invalid
          </div>
        );
      }
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Alternative Email Address',
    dataIndex: 'email_address_2',
    key: 'email_address_2',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, items) => {
      const keyField = 'email_address_2';
      const invalidField = onGetValidation(keyField, items);
      if (invalidField) {
        return (
          <div
            className={validClassNameColumn({ className: '', isValid: false })}
          >
            Data Invalid
          </div>
        );
      }
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Detail Address',
    dataIndex: 'address',
    key: 'address',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, items) => {
      const keyField = 'address';
      const invalidField = onGetValidation(keyField, items);
      if (invalidField) {
        return (
          <div
            className={validClassNameColumn({ className: '', isValid: false })}
          >
            Data Invalid
          </div>
        );
      }
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Postal Code',
    dataIndex: 'postal_code',
    key: 'postal_code',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Gender',
    dataIndex: 'gender',
    key: 'gender',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, items) => {
      const keyField = 'gender';
      const invalidField = onGetValidation(keyField, items);
      if (invalidField) {
        return (
          <div
            className={validClassNameColumn({ className: '', isValid: false })}
          >
            Data Invalid
          </div>
        );
      }
      if (item && typeof item === 'string') {
        return item?.charAt?.(0)?.toUpperCase() + item?.slice(1);
      }
      return '-';
    },
    width: 180,
  },
  {
    title: 'Birth Date',
    dataIndex: 'birth_date',
    key: 'birth_date',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, items) => {
      const keyField = 'birth_date';
      const invalidField = onGetValidation(keyField, items);
      if (invalidField) {
        return (
          <div
            className={validClassNameColumn({ className: '', isValid: false })}
          >
            Data Invalid
          </div>
        );
      }
      const formated = TimeFormatter(item);
      return `${formated.date} ${formated.monthName} ${formated.year}`;
    },
    width: 180,
  },
  {
    title: 'Income per Month',
    dataIndex: 'income_per_month',
    key: 'income_per_month',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, items) => {
      const keyField = 'income_per_month';
      const invalidField = onGetValidation(keyField, items);
      if (invalidField) {
        return (
          <div
            className={validClassNameColumn({ className: '', isValid: false })}
          >
            Data Invalid
          </div>
        );
      }
      if (item) return getFormatCurrency({ currency: 'IDR', value: item });
      return '-';
    },
    width: 180,
  },
  {
    title: 'Education Institution',
    dataIndex: 'education_institutions',
    key: 'education_institutions',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Expertise',
    dataIndex: 'expertises',
    key: 'expertises',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Past Job Title',
    dataIndex: 'past_job_titles',
    key: 'past_job_titles',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Related Organization',
    dataIndex: 'related_organization',
    key: 'related_organization',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Hobbies',
    dataIndex: 'hobbies',
    key: 'hobbies',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Favorites',
    dataIndex: 'favorites',
    key: 'favorites',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Instagram',
    dataIndex: 'ig_username',
    key: 'ig_username',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Facebook',
    dataIndex: 'fb_username',
    key: 'fb_username',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
  {
    title: 'Twitter',
    dataIndex: 'twt_username',
    key: 'twt_username',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      return item || '-';
    },
    width: 180,
  },
];

export default columns;
